var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyCase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6364 0H2.09091C0.940909 0 0 0.940909 0 2.09091V16.7273H2.09091V2.09091H14.6364V0ZM13.5909 4.18182L19.8636 10.4545V20.9091C19.8636 22.0591 18.9227 23 17.7727 23H6.26227C5.11227 23 4.18182 22.0591 4.18182 20.9091L4.19227 6.27273C4.19227 5.12273 5.12273 4.18182 6.27273 4.18182H13.5909ZM12.5455 11.5H18.2955L12.5455 5.75V11.5Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCase);
export default __webpack_public_path__ + "static/media/copyCase.c3eac37918e95760a8b92db783dedd4f.svg";
export { ForwardRef as ReactComponent };